class RocketCollectionInfiniteScroll {
  constructor() {
    this.isLoading = false;
    this.allProductsLoaded = false;

    this.loadMoreElement = document.getElementById('load-more');
    this.productGrid = document.getElementById('product-grid');
    this.gridContainer = document.getElementById('ProductGridContainer');

    if (!this.loadMoreElement || !this.productGrid) return;
    this.handleScroll = this.handleScroll.bind(this);

    window.addEventListener('scroll', this.handleScroll);
  }

  async loadMoreProducts() {
    if (this.isLoading || this.allProductsLoaded) return;
    const loadMoreBtn = document.getElementById('load-more');
    if (!loadMoreBtn) {
      return;
    }
    const url = document.getElementById('load-more').getAttribute('data-href');
    const numberPrePage = parseInt(document.getElementById('load-more').getAttribute('data-per_page'));
    this.productGrid = document.getElementById('product-grid');

    console.log('url', url);

    this.setLoading(true);
    try {
      const res = await fetch(`${url}`);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const btnLoadMore = doc.getElementById('collection-load__more');
      const btnCurrent = document.getElementById('collection-load__more');
      const newProducts = doc.querySelectorAll('#product-grid .grid__item');

      if (newProducts.length) {
        newProducts.forEach((item) => this.productGrid.appendChild(item));
        if (newProducts.length < numberPrePage) this.allProductsLoaded = true;
      } else {
        this.allProductsLoaded = true;
      }
      if (!btnLoadMore) {
        this.allProductsLoaded = true;
        this.setLoading(false);
        return;
      } else {
        btnCurrent.innerHTML = btnLoadMore.innerHTML;
      }
    } catch (err) {
      console.error('Error loading more products:', err);
    }

    this.setLoading(false);
  }

  setLoading(state) {
    this.isLoading = state;
    if (this.loadMoreElement) {
      this.loadMoreElement.style.display = state ? 'block' : this.allProductsLoaded ? 'none' : 'block';
      this.loadMoreElement.classList.toggle('is-loading', state);
    }
  }

  handleScroll() {
    const offsetMargin = 500;
    const container = this.gridContainer || document.body;
    const rect = container.getBoundingClientRect();
    const containerBottom = rect.bottom + window.scrollY;
    const triggerPoint = containerBottom - offsetMargin;
    if (window.innerHeight + window.scrollY >= triggerPoint) {
      this.loadMoreProducts();
    }
  }
}

function initInfiniteScroll() {
  new RocketCollectionInfiniteScroll();
}
initInfiniteScroll();
